import React from "react";
import Separator from "../../core/Separator";
import withTranslation from "../../core/withTranslation";
import ContentFileRepositoryListContainer from "./ContentFileRepositoryListContainer";

const FileRepositoryScene = (props) => (
  <div className="container">
    <Separator size="md" />
    <ContentFileRepositoryListContainer></ContentFileRepositoryListContainer>
  </div>
);

export default withTranslation(FileRepositoryScene);
